import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { RepeatableRangeRuleComponent } from './RepeatableRangeRuleComponent.tsx';

const MAX_RANGE = 50;

const configValidator = yup
  .object({
    min: yup
      .number()
      .notRequired()
      .max(MAX_RANGE)
      .positive()
      .label('Ripetizioni Minime'),
    max: yup
      .number()
      .notRequired()
      .positive()
      .greaterThan('min')
      .max(MAX_RANGE)
      .label('Ripetizioni Massime'),
    minCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
    maxCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

export type IRepeatableRangeRuleOptions = yup.InferType<typeof configValidator>;

export const RepeatableRangeRule: IRuleType<IRepeatableRangeRuleOptions> = {
  type: RuleType.RepeatableRange,
  name: 'Ripetizioni Massime',
  configComponent: RepeatableRangeRuleComponent,
  configValidator,
  validator: (schema, rule) => {
    if (!rule) return schema;

    if (rule.min != null) {
      schema = (schema as yup.ArraySchema<any, any>).min(
        rule.min,
        rule.minCustomMessage ?? undefined,
      );
    }

    if (rule.max != null) {
      schema = (schema as yup.ArraySchema<any, any>).max(
        rule.max,
        rule.maxCustomMessage ?? undefined,
      );
    }

    return schema;
  },
};
